import _, { values } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent } from "BaseComponent";
import Usagehistoryuserdatalist from "./userdatalist-item";
import { converDateIntoLocalwithmonth } from "Constants";

class Viewusagehistorymodal extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            btnLoading: false,
            usersearchText: '',
            eventid: '',
        };
    }

    closeModals = () => {
        this.props.onClose();
    };

    renderList() {
        let searchText = this.state.usersearchText;
        let filtered = [];

        if (this.state.usersearchText !== "") {
            // If Search Key Found
            let listing = this.props.userdata;

            filtered = _.filter(listing, function (o) {
                return o.Username.toLowerCase().indexOf(_.toLower(searchText)) > -1;
            });
        } else {
            filtered = this.props.userdata;
        }

        if (this.state.eventid !== "") {   
            let eventidsearch = this.state.eventid;
            filtered = _.filter(this.props.userdata, function (o) {
                return o.eventid.indexOf(eventidsearch) > -1;
            });
        }

        // console.log('check');
        var items = _.map(filtered, (values, index) => (
            <Usagehistoryuserdatalist
                key={index}
                values={values}
            />
        ));
        // console.log('check', this.state.pageNumber);
        return items;
    }

    handleFilterbyevent = (event) => {
        this.setState({ eventid: event.target.value });
        this.renderList();
    };


    render() {
        let { initialValues, userdata, lastdate, firstdate,usagehistoryDatalist } = this.props;
        let firstDate = '';
        let lastDate = '';
        firstDate = converDateIntoLocalwithmonth(firstdate).format("D MMM YYYY");
        lastDate = converDateIntoLocalwithmonth(lastdate).format("D MMM YYYY");

        let options = [];

        options.push(
            <option
                value=""
                selected={this.state.eventid === "" ? "selected" : ""}
            >
                {LocaleStrings.accountsetting_usagehistory_modalfilterwithevent}
            </option>
        );
        if (usagehistoryDatalist && usagehistoryDatalist.eventdata && usagehistoryDatalist.eventdata.length > 0) {
            _.map(usagehistoryDatalist.eventdata, (item, index) => {
                let selected =
                    this.state.eventid === item.eventid ? "selected" : "";

                options.push(
                    <option key={index} value={item.eventid} selected={selected}>
                        {item.eventname}
                    </option>
                );
            });
        }

      
        return (
            <Modal
                show={this.props.isOpen}
                onHide={this.closeModals}
                className=""
                dialogClassName="contact-eventify-modal"
            >
                <Modal.Header >
                    <Modal.Title>
                        <div className="title-modal">{LocaleStrings.accountsetting_usagehistory_modalheader} ({firstDate} to {lastDate})</div>
                    </Modal.Title>
                    <button
                        type="button"
                        className="i-custom-cross-popup pull-right"
                        onClick={this.closeModals}
                    >
                        <img
                            className="i-custom-small"
                            src="../../style/images/custom-icons/cross-black.png"
                        />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {userdata && userdata.length > 0 ? (
                        <>
                            <div className="d-flex">
                                <input
                                    className="form-control mapsearch"
                                    style={{ width: "300px" }}
                                    placeholder={"Search"}
                                    type="text"
                                    onChange={(e) =>
                                        this.setState({ usersearchText: e.target.value })
                                    }
                                    value={this.state.usersearchText}
                                />
                                {usagehistoryDatalist && usagehistoryDatalist.eventdata && usagehistoryDatalist.eventdata.length > 1 ?(
                                     <div style={{ marginLeft: 'auto' }}>
                                     <ul className="header-buttons pull-right">
                                         <li key="filter" className="schedule-button users-button">
                                             <select
                                                 onChange={(e) => this.handleFilterbyevent(e)}
                                                 className="form-control selectbox dropdown-height-border"
                                             >
                                                 {options}
                                             </select>
                                         </li>
                                     </ul>
                                 </div>
                                ):('')}
                               
                            </div>
                            <div className="">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th align="center">
                                                {LocaleStrings.accountsetting_usagehistory_modaltable_th1}
                                            </th>
                                            <th align="center">
                                                {LocaleStrings.accountsetting_usagehistory_modaltable_th4}
                                            </th>
                                            <th align="center">
                                                {LocaleStrings.accountsetting_usagehistory_modaltable_th3}
                                            </th>
                                            <th align="center">
                                                {LocaleStrings.accountsetting_usagehistory_modaltable_th2}
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody className="tbody-background">
                                        {this.renderList()}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (<div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>No Data found</div>)}
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <div className="pull-left h-100 vertical-align-center">
                        </div>
                        <div className="pull-right h-100 vertical-align-center" style={{ marginLeft: 'auto' }}>
                            <Button variant="secondary" onClick={this.closeModals}>
                                {LocaleStrings.accountsetting_billingdetails_contacteventify_modalclose}
                            </Button>

                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        session: state.session,
        userdata: ownProps.data,
        firstdate: ownProps.firstdate,
        lastdate: ownProps.lastdate,
        usagehistoryDatalist: state.usagehistoryDatalist
    };
}
export default connect(mapStateToProps, {
})(
    reduxForm({
        form: "ViewusagehistorymodalForm",
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
    })(Viewusagehistorymodal)
);